import * as React from "react";
const SvgServiceStatusDark = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, "data-name": "icon info", style: {
  width: 16,
  height: 16
}, role: "img", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 0a8 8 0 1 0 8 8 8 8 0 0 0-8-8Zm1 13H7V7h2Zm0-7.88a1.56 1.56 0 0 1-1 .38 1.5 1.5 0 0 1 0-3 1.54 1.54 0 0 1 1.11.5A1.5 1.5 0 0 1 9 5.12Z" }));
export default SvgServiceStatusDark;
